module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAANVJREFUSEvt1L0SwUAUhuH369wA7gGdnzGkonPFGhoTjVS4i7gB1TFrIphJQrKrk3KzeXbznTNHlDxm1gXWwFXStGxf2bqKXmToFugBB0kTbzhDN0AfOAJLSRcv2Mw6gLupQ08ZmtZF3f48ipBoDodGX+EEGDb55YJv9pLm9yjMLAZmgeBYUlTYbiEO+MN5io/i7YAoRLbAs3iBuyKRNPYunpm1szEwAM7AQlLqBZehb7Oibr5VaGP4E+oDH4BR1WhtlLGZufZsAStXqKIYG8Hf1ONn8A3PbVkX/sSXMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/switch.png
// module id = ZfGK
// module chunks = 1